import script from "./offersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./offersView.vue?vue&type=script&setup=true&lang=ts"

import "./offersView.vue?vue&type=style&index=0&id=8f5cdce6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f5cdce6"]])

export default __exports__